// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__oxo1R","containerQuiz":"Quiz_containerQuiz__U9j2p"};